import { useEffect, useState, useRef } from "react";
import TextField from "@mui/material/TextField";
import BarraBotones from "./BarraBotones.jsx";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import Table from "react-bootstrap/Table";

import { RUTA_SERVIDOR } from "../componentes/config.js";

const ForoTemas = (props) => {
  const testRef = useRef(null);
  const scrollToElement = () => testRef.current.scrollIntoView();
  const [cargando, setCargando] = useState(false);
  const [idProyecto, setIdProyecto] = useState("");
  const [proyectos, setProyectos] = useState([]);
  const [foros, setForos] = useState([]);
  const [cant, setCant] = useState(0);
  const [registro, setRegistro] = useState({
    Id: "",
    Nbre: "",
    Activo: true,
  });

  useEffect(() => {
    const cargarProyectos = async () => {
      cargarListas("getCbos", { Tabla: "proyectos", Campo: "" }, "proyectos");
    };

    cargarProyectos();

    nuevo();
  }, [props.tabla, props.titulo]);

  const asignarDato = (event) => {
    event.preventDefault();
    if (event.target.name === "Activo") {
      setRegistro({ ...registro, [event.target.name]: event.target.checked });
    } else {
      setRegistro({ ...registro, [event.target.name]: event.target.value });
    }
  };

  const asignarProyecto = async (id) => {
    setIdProyecto(id);
    nuevo();
    cargarListas("getForos", { Proyecto: id }, "foros");
  };

  const cargarForos = async (id) => {
    setIdProyecto(id);
    cargarListas("getForos", { Proyecto: id }, "foros");
  };

  const cargarListas = async (url, cuerpo, array) => {
    try {
      const reg = await fetch(RUTA_SERVIDOR + url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cuerpo),
      });

      const lista = await reg.json();
      if (lista.toString().length > 0) {
        if (array === "foros") {
          setForos(lista);
          setCant(lista.length);
        } else if (array === "proyectos") {
          setProyectos(lista);
        }
      } else {
        if (array === "foros") {
          setForos([]);
          setCant(0);
          nuevo();
        } else if (array === "proyectos") {
          setProyectos([]);
        }
      }

      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg(["Ocurrió un error al cargar los datos!"]);
    }
  };

  const botones = (btn) => {
    if (btn === 0) nuevo();
    else if (btn === 1) validarDatos();
    else if (btn === 2) imprimir();
    else if (btn === 3) exportar();
    else if (btn === 4) nuevo();
    scrollToElement();
  };

  const imprimir = () => {
    props.mostrarMsg(["OK, Imprime los datos"]);
  };

  const exportar = () => {
    props.mostrarMsg(["OK, exportará los datos"]);
  };

  const cargarFila = (event, reg) => {
    event.preventDefault();
    setRegistro({
      ["Id"]: reg.Id,
      ["Nbre"]: reg.Nbre,
      ["Activo"]: reg.Activo === "Activo" ? 1 : 0,
    });
    scrollToElement();
  };

  const validarDatos = () => {
    if (idProyecto === "" || idProyecto === 0 || idProyecto === "0") {
      props.mostrarMsg([
        "Por favor seleccione le Proyecto al cual quiere crearle un Foro!",
      ]);
    } else if (registro.Nbre === "") {
      props.mostrarMsg(["Por favor digite el Nombre"]);
    } else {
      {
        registro.Id === "" ? grabarRegistro() : modificarRegistro();
      }
    }
  };

  const grabarRegistro = async () => {
    try {
      const reg = await fetch(RUTA_SERVIDOR + "setForoTemas", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Nbre: registro.Nbre,
          Activo: registro.Activo ? 1 : 0,
          Tabla: "foro_temas",
          Proyecto: idProyecto,
          IdUsuario: props.idUsuario,
        }),
      });

      const propues = await reg.json();
      if (propues.toString().length > 0) {
        setRegistro({ ...registro, ["Id"]: propues.Id });
        cargarForos(idProyecto);
        props.mostrarMsg(["Felicidades!!!", "Registro Grabado!"]);
      } else {
        props.mostrarMsg(["Ocurrió un error al Grabar!"]);
      }

      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg(["Ocurrió un error al Grabar!"]);
    }
  };

  const modificarRegistro = async () => {
    try {
      const reg = await fetch(RUTA_SERVIDOR + "updateForoTemas", {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: registro.Id,
          Nbre: registro.Nbre,
          Activo: registro.Activo,
          Tabla: "foro_temas",
          IdUsuario: props.idUsuario,
        }),
      });

      const resp = await reg.json();
      if (resp.result.affectedRows === 1) {
        cargarForos(idProyecto);
        props.mostrarMsg(["Felicidades!!!", "Registro Modificado!"]);
      } else {
        props.mostrarMsg(["Ocurrió un error al Modificar los datos!"]);
      }

      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg(["Ocurrió un error al Modificar el registro"]);
    }
  };

  const nuevo = () => {
    setRegistro({
      Id: "",
      Nbre: "",
      Activo: true,
    });
  };

  return (
    <div className="container-fluid" ref={testRef}>
      <div className="row card">
        <Alert severity="success">
          <strong>TEMAS DE FORO</strong>
          {cargando === true && (
            <div className="spinner-grow text-primary" role="status">
              <span className="visually">Cargando...</span>
            </div>
          )}
        </Alert>

        <div className="row mt-3">
          <BarraBotones
            botones={botones}
            btnActivos={[true, true, false, true, true]}
          />
        </div>

        <div className="form-floating mb-2 mt-2">
          <select
            type="text"
            className="form-control"
            name="idProyecto"
            value={idProyecto}
            onChange={(event) => {
              asignarProyecto(event.target.value);
            }}
          >
            <option key="0" value="0">
              Por favor seleccione un Proyecto...
            </option>
            {proyectos.map((reg) => {
              return (
                <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                  {" "}
                  {reg.Nbre}{" "}
                </option>
              );
            })}
          </select>
          <label htmlFor="idProyecto">Proyecto Actual</label>
        </div>

        <div className="row mb-3 m-0">
          <TextField
            name="Id"
            label="ID"
            className="form-control"
            type="text"
            value={registro.Id}
            disabled
          />
        </div>

        <div className="row mb-3 m-0">
          <TextField
            autoFocus={true}
            name="Nbre"
            label="Nombre"
            className="form-control"
            type="text"
            value={registro.Nbre}
            onChange={asignarDato}
          />
        </div>

        <div className="row mt-3">
          <div className="form-check form-switch m-3">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              name="Activo"
              size={"large"}
              checked={registro.Activo}
              onChange={asignarDato}
            />
            <label className="form-check-label text-end" htmlFor="Activo">
              {registro.Activo === true ? "Estado: ACTIVO" : "Estado: ANULADO"}
            </label>
          </div>
        </div>
      </div>

      <Divider component="ul" />
      <div className="row mt-3">
        <BarraBotones
          botones={botones}
          btnActivos={[true, true, false, true, true]}
        />
      </div>

      <div className="row card">
        <h3 className="mt-3 mb-3">LISTADO - Cantidad: {cant}</h3>
        <Table className="table table-hover table-bordered" responsive>
          <thead className="table-primary">
            <tr>
              <th scope="col"># ITEM</th>
              <th scope="col">NOMBRE</th>
              <th scope="col" className="text-center">
                ESTADO
              </th>
              <th scope="col" className="text-center">
                ACCION
              </th>
            </tr>
          </thead>
          <tbody>
            {foros.length > 0 &&
              foros.map((reg, i) => {
                return (
                  <tr
                    className={reg.Activo === "Inactivo" ? "table-danger" : ""}
                    key={i}
                  >
                    <th> {i + 1} </th>
                    <th> {reg.Nbre} </th>
                    <th> {reg.Activo} </th>
                    <th>
                      <a
                        href="divTop"
                        className="btn btn-primary form-control"
                        onClick={(event) => {
                          cargarFila(event, reg);
                        }}
                      >
                        Editar
                      </a>
                    </th>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ForoTemas;
